import './style.scss'

export default {
  name: 'SplitLabel',
  functional: true,
  props: {
    label: {
      type: String,
      default: ''
    },
    colon: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { label, colon, className } = context.props
    const labelBreak = label.split('')
    return (
      <div class={['label-split', ...className.split(' ')]}>
        {
          labelBreak.map((item, idx) =>
            (
              <span key={idx}>
                { item }{ idx === labelBreak.length - 1 && colon && ':' }
              </span>
            )
          )
        }
      </div>
    )
  }
}
